import { crudActions } from '../factories'
import { moduleState } from 'cerebral'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'surveys' })

export const togglePublished = async ({ props: { id }, surveysService: service, get }) => {
  if (id) {
    const published = get(moduleState`entities.${id}.published`)
    const data = await service.patch(id, { published: !published })
    return { entities: { surveys: [data] } }
  }
}
